import { Navigate } from "react-router-dom";
import { getInfraDev } from "../runtimeConfig";

const ProtectedRoute = ({ children }) => {
  // Bypass auth on OD / ephemeral when INFRA_ENV is present in config.js
  const disableAuth = !!getInfraDev();

  if (disableAuth) {
    return children;
  }

  const isLoggedIn = localStorage.getItem("__ac_user");

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
